import {
  Button,
  Grid,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  OverflowTooltip,
  Space,
  TextLabel,
} from '@tonic-one/react';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import {
  InputChildRef,
  InputWithValid,
} from '../../../../components/Common/Form/InputWithValid';
import { ValidProps } from '../../../../types';
import {
  validateEmail,
  validateIsNotEmptyString,
} from '../../../../utils/validate';

export const AddModal = React.memo(
  (props: {
    allData: string[];
    visible: boolean;
    onSave: (value: string) => void;
    onClose: () => void;
    title: string;
  }) => {
    const { t } = useTranslation();
    const [value, setValue] = React.useState('');
    const childRef = useRef<InputChildRef>(null);
    const validates: ValidProps[] = [
      {
        validMethod: validateEmail,
        errMsg: t('common.error.invalidEmailAddress'),
      },
      {
        validMethod: validateIsNotEmptyString,
        errMsg: t('common.error.invalidFormat'),
      },
      {
        validMethod: (value: string) => {
          return !props.allData.includes(value);
        },
        errMsg: t('common.error.duplicateEmailAddress'),
      },
    ];

    return (
      <Modal
        closeOnEsc
        closeOnOutsideClick
        isClosable
        isOpen={props.visible}
        onClose={props.onClose}
        size="sm"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <OverflowTooltip>{props.title}</OverflowTooltip>
          </ModalHeader>
          <ModalBody>
            <Grid templateColumns="min-content auto" columnGap="3x" rowGap="3x">
              <Grid>
                <TextLabel whiteSpace="nowrap">
                  {t(
                    'globalSetting.DNSDetectionExceptionList.column.emailAddress'
                  )}
                  :<Space color="red:50">*</Space>
                </TextLabel>
              </Grid>
              <Grid>
                <InputWithValid
                  width={300}
                  ref={childRef}
                  value={value}
                  onChange={setValue}
                  validates={validates}
                  maxLength={256}
                  placeholder={t(
                    'globalSetting.DNSDetectionExceptionList.column.emailAddress'
                  )}
                />
              </Grid>
            </Grid>
          </ModalBody>
          <ModalFooter>
            <Button
              variant="primary"
              minWidth="20x"
              onClick={async () => {
                /**
                 * if children has errorMsg,then not save
                 */
                await childRef.current?.validate(value);
                if (childRef.current?.errorMsg !== undefined) return;

                props.onSave(value);
              }}
            >
              {t('common.button.save')}
            </Button>
            <Space width="2x" />
            <Button minWidth="20x" onClick={props.onClose}>
              {t('common.button.cancel')}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  }
);
